import { SlideMenuProps } from "#/shared/components/SlideMenu"
import { SWAP_TOKENS } from "#/shared/constants"
import { SwappableToken } from "#/shared/types"

import SwapModalAssetSelectorItem from "./SwapModalAssetSelectorItem"
import SwapModalFormSettingsWrapper from "./SwapModalFormSettingsWrapper"

export type SwapModalAssetSelectorProps = Pick<
  SlideMenuProps,
  "isOpen" | "onClose"
> & {
  currentToken: SwappableToken | null
  onTokenSelect: (token: SwappableToken) => void
}

export default function SwapModalAssetSelector({
  isOpen,
  currentToken,
  onTokenSelect,
  onClose,
}: SwapModalAssetSelectorProps) {
  return (
    <SwapModalFormSettingsWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Select an asset"
    >
      {SWAP_TOKENS.filter((token) => token !== "MUSD").map((token) => (
        <SwapModalAssetSelectorItem
          key={token}
          token={token}
          currentToken={currentToken}
          onClick={(e) => {
            onTokenSelect(token)
            onClose(e)
          }}
        />
      ))}
    </SwapModalFormSettingsWrapper>
  )
}
